import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import Spinner from '../Spinner/Spinner';
import { renderName } from '../../utils/renderName';
import Header from '../Header/Header';
import Consent from '../Consent/Consent';
import Footer from '../Footer/Footer';
import Error from '../Error/Error';
import { validLocale, validEmailId, validUserId, validAccountType, validChannel, validUnsubscribe, validCluster } from '../../utils/validate';
import { setPageDataLayer } from '../../utils/GTM';
import { createLogs } from '../../utils/proactiveMonitoring';
import { generateString, getCurrentServerTimeStamp } from '../../utils/hmac';
import { consentApiForVeeva, consentApiForGigya } from '../../utils/api';
import { anyConsentsChecked, orderConsents, unsubscribeChannels } from '../../utils/consentOrder';
import './LoadPage.scss';
import i18n from '../../i18n';
import globalConfig from '../../config/global/config.json';
import { objectTransformer } from '../../utils/objectTransformer';
import OneClickProcessingPopup from '../OneClickProcessingPopup/OneClickProcessingPopup';

class LoadPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      onLoad: true,
      onUpdate: false,
      userId: null,
      emailId: null,
      countryCode: null,
      consents: [],
      profile: {
        title: "",
        lastName: "",
        firstName: ""
      },
      message: {
        active: false,
        type: "ERR_CSP-10001"
      }
    }
  }
  

  async componentDidMount() {
    let res;
    const { locale } = this.props;
    const userId = sessionStorage.getItem('id');
    const emailId = sessionStorage.getItem('em');
    const cluster = sessionStorage.getItem('cluster');
    const accountType = sessionStorage.getItem('acctype');
    const channel = sessionStorage.getItem('channel');
    const unsubscribe = sessionStorage.getItem('unsubscribe');
    const decryptionFailure = sessionStorage.getItem('decryptionFailure');
    const validateUrl = ["cluster","locale", "decryptionFailure", "userId", "emailId", "accountType", "oneClickOptOut", "getConsent"];
    loop: for (let obj of validateUrl) {
      switch (obj) {
        case "cluster":
          if (cluster) {
            if (!validCluster(cluster)) {
              this.handleError("ERR_CSP-10010", "Invalid cluster name", true, locale);
              break loop;
            }
          }
          break;
        case "locale":
          if (locale === "" || locale === undefined || locale === null) {
            i18n.changeLanguage(globalConfig.SET_DEFAULT_MARKET);
            sessionStorage.setItem('locale',globalConfig.SET_DEFAULT_MARKET);
            this.handleError("ERR_CSP-10005", "Locale not available", true, locale);
            break loop;
          } else if (!validLocale(locale, cluster)) {
            this.handleError("ERR_CSP-10001", "Invalid Locale", true, locale);
            break loop;
          }
          break;
        case "decryptionFailure":
          if (decryptionFailure) {
            this.handleError("ERR_CSP-10006", "Decryption Failure", true, locale);
            break loop;
          }
          break;
        case "userId":
          if (!validUserId(userId)) {
            this.handleError("ERR_CSP-10003", "Invalid User ID", true, locale);
            break loop;
          }
          break;
        case "emailId":
          if (!validEmailId(emailId)) {
            this.handleError("ERR_CSP-10004", "Invalid Email ID", true, locale);
            break loop;
          }
          break;
        case "accountType":
          if(accountType){            
            if(!validAccountType(accountType)){
              this.handleError("ERR_CSP-10007","Invalid account type",true,locale); 
              break loop;
            }
          }
          break;
        case "oneClickOptOut":
          if(channel && unsubscribe){
            // validate if the channel is present in the global consent lists 
            if (!validChannel(channel, globalConfig.SET_CONSENT_ORDER)) {
              sessionStorage.setItem('oneClickOptOut', false);
            }
            else if(!validUnsubscribe(unsubscribe)){
              createLogs("2", {
                data: "Invalid value in unsubscribe parameter",
                errorCode: "ERR_CSP-10009",
                locale
              });
            }
            else {
              sessionStorage.setItem('oneClickOptOut',false);
            }
          }
          break;
        case "getConsent": {
          const countryCode = this.fetchBuIdForMarket();
          createLogs("1", {
            requestName: 'get_Consent_call_before_triggering',
            locale
          })
          let timeStamp = getCurrentServerTimeStamp('YYYY-MM-DD HH:mm:ss');
          let customStrVal;
          if (this.isGigyaUser()) {
            customStrVal = generateString('POST', emailId, timeStamp, true);
            const payload = {
              "email": emailId,
              "context": { "accountType": accountType }
            }
            if (accountType === 'full') {
              payload.UID = userId;
            }
            res = await consentApiForGigya(countryCode, payload, 'POST', customStrVal, timeStamp);
          } else {
            customStrVal = generateString('GET', userId, timeStamp);
            res = await consentApiForVeeva(countryCode, userId, emailId, false, 'GET', customStrVal, timeStamp);
          }
          if (res.data) {
            this.handleSuccessResponse(res.data.subscriptions ? objectTransformer(res, 'GET') : res, userId, emailId, countryCode);
          } else {
            this.handleError("ERR_APG-CSP-10400", "No response from Apigee", true, locale);
          }
          break;
        }
        default: 
          break;
      }
    }
    this.setFavicon();
  }

  faviconPath = () => i18n.exists("configuration:SET_FAVICON_PATH") ? i18n.t("configuration:SET_FAVICON_PATH") : globalConfig.SET_FAVICON_PATH ;

  setFavicon = () => {
    const favicon = document.getElementById('favicon');
    favicon.href = this.faviconPath();
  }

  handleChange = e => {
    const enableUnsubscribe = i18n.exists("configuration:SET_ENABLE_UNSUBSCRIBE_ALL") ? i18n.t("configuration:SET_ENABLE_UNSUBSCRIBE_ALL") : globalConfig["SET_ENABLE_UNSUBSCRIBE_ALL"];
    const { consents } = this.state;
    const consent = consents[e.target.value];
    if (consent.name === "unsubscribeAll") {
      let newConsents = consents.map(c => { return { ...c, isChecked: false } });
      newConsents[consents.length - 1].isChecked = true;
      this.setState({ consents: newConsents })
    } else if (enableUnsubscribe){
      if (!consent.isChecked) {
        consents[consents.length - 1].isChecked = false;
      }
      consents[e.target.value].isChecked = !this.state.consents[e.target.value].isChecked;
      if (!anyConsentsChecked(consents)) {
        consents[consents.length - 1].isChecked = true;
      }
      this.setState({ consents });
    } else {
      consents[e.target.value].isChecked = !this.state.consents[e.target.value].isChecked;
      this.setState({ consents});
    }
  };

  handleSubmit = async () => {
    this.setState({ onUpdate: true })
    const { userId, emailId, countryCode, consents } = this.state;
    const locale = sessionStorage.getItem('locale');
    const accountType = sessionStorage.getItem('acctype');
    let res;
    createLogs("1", {
      data: {
        userId,
        emailId,
        consents,
        countryCode
      },
      requestName: 'put_Consent_call_before_triggering',
      locale
    })
    let timeStamp = getCurrentServerTimeStamp('YYYY-MM-DD HH:mm:ss');
    if (this.isGigyaUser()) {
      let customStrVal = generateString('PUT', emailId, timeStamp, true);
      const subscriptionsObj = objectTransformer(consents, 'UPDATE');
      const payload = {
        "context": { "accountType": accountType },
        "profile":
        {
          "email": emailId
        },
        "subscriptions": subscriptionsObj
      };
      if (accountType === 'full') {
        payload.UID = userId;
      }
      res = await consentApiForGigya(countryCode, payload, 'PUT', customStrVal, timeStamp);
    } else {
      let customStrVal = generateString('PUT', userId, timeStamp);
      res = await consentApiForVeeva(countryCode, userId, emailId, consents, 'PUT', customStrVal, timeStamp);
    }
    if (res) {
      if (res.data.Code === "200" || res.data.statusCode === 200) {
        setPageDataLayer();
        this.handleError("successMessage", "", false, locale);
      } else {
        this.handleError(res.data.Error, "", true, locale);
      }
    } else {
      this.handleError("ERR_APG-CSP-10400", "Invalid response from Apigee", true, locale);
    }
  }

  handleError = (errorCode, data, creatingLogs, locale) => {
    if (creatingLogs) {
      createLogs("2", {
        data,
        errorCode,
        locale
      })
    }
    errorCode = i18n.exists(`errors#${errorCode}`) ? errorCode : "default";
     this.setState({
     onLoad: false,
     message: {
       active: true,
       type: errorCode
     }
   })
 }

  handleSuccessResponse = (res, userId, emailId, countryCode) => {
    const locale = sessionStorage.getItem('locale');
    const channel = sessionStorage.getItem('channel');
    const unsubscribe = sessionStorage.getItem('unsubscribe');
    if (res.data.RetrieveConsent) {
      let { consents, profile } = res.data.RetrieveConsent;
      let finalConsents = orderConsents(consents);
      let shouldAutoSubmit = false;

      if (sessionStorage.getItem("oneClickOptOut") !== null) {
        // validate if the channel is present for the market
        const enabledConsentsForMarket = consents.map((consent) => consent.name);
        if (validChannel(channel, enabledConsentsForMarket)) {
          sessionStorage.setItem('oneClickOptOut', unsubscribe);
          finalConsents = orderConsents(unsubscribeChannels(consents));
          if (unsubscribe === "true") {
            shouldAutoSubmit = true;
          }
        } else {
          sessionStorage.setItem('oneClickOptOut', false);
        }
      }

      this.setState({
        onLoad: false,
        userId,
        emailId,
        countryCode,
        consents: finalConsents,
        profile
      }, () => {
        if (shouldAutoSubmit) {
          this.handleSubmit();
        }
      });
    } else {
      this.handleError(res ? res.data.Error : "ERR_CSP-10002", res ? this.props.t(res.data.Error) : this.props.t("ERR_CSP-10002"), true, locale);
    }
  };

  // Method to check if user is from Gigya or not
  isGigyaUser = () => {
    const isDynamicConsentSourceEnabled = i18n.exists("configuration:SET_ENABLE_DYNAMIC_CONSENT_SOURCE") ? i18n.t('configuration:SET_ENABLE_DYNAMIC_CONSENT_SOURCE') : globalConfig.SET_ENABLE_DYNAMIC_CONSENT_SOURCE;
    const accountType = sessionStorage.getItem('acctype');
    return accountType && isDynamicConsentSourceEnabled;
  };

  fetchBuIdForMarket = () => {
    var locale = sessionStorage.getItem("locale"),
      buid = "",
      langSelector = i18n.exists("configuration:SET_ENABLE_LANG_DROPDOWN") ? this.props.t("configuration:SET_ENABLE_LANG_DROPDOWN") : globalConfig.SET_ENABLE_LANG_DROPDOWN;
    if (langSelector === true && this.isGigyaUser()) {
      buid = (locale.split("-"))[1].toUpperCase() + "-" + (locale.split("-"))[0];
    }
    else {
      buid = (locale.split("-"))[1].toUpperCase();
    }
    return buid;
  };
  
  render() {
    const { t } = this.props;
    const oneClickOptOut = sessionStorage.getItem("oneClickOptOut");
    return (
      <div>
        <div>
          <Header />
          <div className="container-fluid px-3">
            {this.state.onLoad || (!this.state.message.active && oneClickOptOut === 'true') ? <h1 className="container page-title py-3 ps-0"> </h1> :
              <h1 className="container page-title py-3 ps-0 pe-3"><span className="page-title-span">{t("pageHeading")}</span>{renderName(this.state.profile)}</h1>}
          </div>
          <div className="container-fluid px-3 pb-2">
            {this.state.message.active ?
              <Error type={this.state.message.type} />
              :
              <div>
                {!this.state.onUpdate || oneClickOptOut === 'true' ?
                  null : <Spinner />}

                {oneClickOptOut === 'true' ?
                  <OneClickProcessingPopup />
                  : this.state.onLoad ?
                    <div className="container px-3 consent-load-container pt-3"> <Spinner /></div>
                    : <Consent
                      consents={this.state.consents}
                      handleChange={this.handleChange}
                      handleSubmit={this.handleSubmit} />}
              </div>}
          </div>
          <Footer />
        </div>
      </div>
    )
  }
}
export default withTranslation()(LoadPage);
